var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "20px", height: "95%" },
          attrs: {
            title: _vm.title,
            width: 1300,
            visible: _vm.visible,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "关闭",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "div",
            { staticClass: "table-page-search-wrapper" },
            [
              _c(
                "a-form",
                {
                  attrs: { layout: "inline" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.searchQuery.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "单据编号",
                                labelCol: { span: 5 },
                                wrapperCol: { span: 18, offset: 1 },
                              },
                            },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "请输入单据编号查询" },
                                model: {
                                  value: _vm.queryParam.number,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParam, "number", $$v)
                                  },
                                  expression: "queryParam.number",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "商品信息",
                                labelCol: { span: 5 },
                                wrapperCol: { span: 18, offset: 1 },
                              },
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "请输入名称、规格、型号",
                                },
                                model: {
                                  value: _vm.queryParam.materialParam,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryParam,
                                      "materialParam",
                                      $$v
                                    )
                                  },
                                  expression: "queryParam.materialParam",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "单据日期",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("a-range-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  format: "YYYY-MM-DD",
                                  placeholder: ["开始时间", "结束时间"],
                                },
                                on: {
                                  change: _vm.onDateChange,
                                  ok: _vm.onDateOk,
                                },
                                model: {
                                  value: _vm.queryParam.createTimeRange,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryParam,
                                      "createTimeRange",
                                      $$v
                                    )
                                  },
                                  expression: "queryParam.createTimeRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "table-page-search-submitButtons",
                          staticStyle: { float: "left", overflow: "hidden" },
                        },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.searchQuery },
                                },
                                [_vm._v("查询")]
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  on: { click: _vm.searchReset },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("a-table", {
            ref: "table",
            attrs: {
              bordered: "",
              size: "middle",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading,
              rowSelection: {
                selectedRowKeys: _vm.selectedRowKeys,
                onChange: _vm.onSelectChange,
                type: _vm.getType,
              },
              customRow: _vm.rowAction,
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "numberCustomRender",
                fn: function (text, record) {
                  return _c("span", {}, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.myHandleDetail(record)
                          },
                        },
                      },
                      [_vm._v(_vm._s(record.number))]
                    ),
                  ])
                },
              },
            ]),
          }),
          _c("bill-detail", { ref: "modalDetail" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }